import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Candidate Selection\n          ")
], -1);
const _hoisted_5 = { class: "text-gray-700" };
const _hoisted_6 = { class: "col-span-6 mt-4" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", {
    for: "offer_stage",
    class: "block text-sm font-medium text-gray-700"
}, "How many candidates are proceeding to offer stage?: *", -1);
const _hoisted_8 = ["value", "disabled"];
const _hoisted_9 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_10 = { class: "col-span-6 mt-4" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", {
    for: "offering_to",
    class: "block text-sm font-medium text-gray-700"
}, "Please provide the names of the Candidates you are offering to:", -1);
const _hoisted_12 = ["value", "disabled", "onInput"];
const _hoisted_13 = {
    key: 0,
    class: "absolute text-red-600 top-2 right-2"
};
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("p", null, "Do you want the recruitment team to send any regret letters? *", -1);
const _hoisted_15 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_16 = { class: "mt-4 space-y-4" };
const _hoisted_17 = { class: "flex items-start" };
const _hoisted_18 = { class: "h-5 flex items-center" };
const _hoisted_19 = ["disabled", "checked"];
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "regret_letters",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_21 = { class: "flex items-start" };
const _hoisted_22 = { class: "h-5 flex items-center" };
const _hoisted_23 = ["disabled", "checked"];
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "regret_letters",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("p", null, "Are you withdrawing any roles? *", -1);
const _hoisted_26 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_27 = { class: "mt-4 space-y-4" };
const _hoisted_28 = { class: "flex items-start" };
const _hoisted_29 = { class: "h-5 flex items-center" };
const _hoisted_30 = ["disabled", "checked"];
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "withdrawing_roles",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_32 = { class: "flex items-start" };
const _hoisted_33 = { class: "h-5 flex items-center" };
const _hoisted_34 = ["disabled", "checked"];
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "withdrawing_roles",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("p", null, "Is re-advertising required? *", -1);
const _hoisted_37 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_38 = { class: "mt-4 space-y-4" };
const _hoisted_39 = { class: "flex items-start" };
const _hoisted_40 = { class: "h-5 flex items-center" };
const _hoisted_41 = ["disabled", "checked"];
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "re_advertising",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_43 = { class: "flex items-start" };
const _hoisted_44 = { class: "h-5 flex items-center" };
const _hoisted_45 = ["disabled", "checked"];
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "re_advertising",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_47 = { class: "mt-6" };
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("label", {
    for: "approval_comments",
    class: "block text-sm font-medium text-gray-700"
}, "Additional comments for the Recruitment Team:", -1);
const _hoisted_49 = ["disabled", "value"];
const _hoisted_50 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_51 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ModalWindow = _resolveComponent("ModalWindow");
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("p", _hoisted_5, "Approved number of candidates: " + _toDisplayString(_ctx.approvedRoles), 1),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createTextVNode(),
                    _createElementVNode("input", {
                        id: "offering_to-input",
                        value: _ctx.data.selection?.offer_stage,
                        type: "text",
                        name: "offer_stage",
                        class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                        disabled: _ctx.disableForm,
                        onInput: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                        onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.data?.selection?.offer_stage.$touch()))
                    }, null, 42, _hoisted_8),
                    _createTextVNode(),
                    (_ctx.v$.data?.selection?.offer_stage.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "\n                * " + _toDisplayString(_ctx.v$.data?.selection?.offer_stage.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberOfOffers + _ctx.cancelledOffers?.length || 0, (n, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: n,
                            class: "relative"
                        }, [
                            _createElementVNode("input", {
                                id: "offering_to-input",
                                value: _ctx.data.selection?.offering_to[index],
                                type: "text",
                                name: "offering_to",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                                disabled: _ctx.disableForm || (_ctx.offeringToCopy && JSON.parse(_ctx.offeringToCopy)?.includes(_ctx.data.selection.offering_to[index])),
                                onInput: ($event) => (_ctx.handleNameInput($event, index))
                            }, null, 42, _hoisted_12),
                            _createTextVNode(),
                            (_ctx.data?.offersArray && _ctx.data?.offersArray[index]?.active === 'CANCELLED')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Cancelled"))
                                : _createCommentVNode("", true)
                        ]));
                    }), 128))
                ]),
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _hoisted_14,
                    _createTextVNode(),
                    (_ctx.v$.data?.selection?.regret_letters.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, "\n                * " + _toDisplayString(_ctx.v$.data?.selection?.regret_letters.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("input", {
                                id: "radio_button_regret_letters_Yes",
                                value: "Yes",
                                name: "regret_letters",
                                type: "radio",
                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                                disabled: _ctx.disableForm,
                                checked: _ctx.data.selection?.regret_letters === 'Yes',
                                onChange: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.data?.selection?.regret_letters.$touch()))
                            }, null, 42, _hoisted_19)
                        ]),
                        _createTextVNode(),
                        _hoisted_20
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("input", {
                                id: "radio_button_regret_letters_No",
                                value: "No",
                                name: "regret_letters",
                                type: "radio",
                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                                disabled: _ctx.disableForm,
                                checked: _ctx.data.selection?.regret_letters === 'No',
                                onChange: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.data?.selection?.regret_letters.$touch()))
                            }, null, 42, _hoisted_23)
                        ]),
                        _createTextVNode(),
                        _hoisted_24
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _hoisted_25,
                    _createTextVNode(),
                    (_ctx.v$.data?.selection?.withdrawing_roles.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, "\n                * " + _toDisplayString(_ctx.v$.data?.selection?.withdrawing_roles.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("input", {
                                id: "radio_button_withdrawing_roles_Yes",
                                value: "Yes",
                                name: "withdrawing_roles",
                                type: "radio",
                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                                disabled: _ctx.disableForm,
                                checked: _ctx.data.selection?.withdrawing_roles === 'Yes',
                                onChange: _cache[6] || (_cache[6] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.data?.selection?.withdrawing_roles.$touch()))
                            }, null, 42, _hoisted_30)
                        ]),
                        _createTextVNode(),
                        _hoisted_31
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("input", {
                                id: "radio_button_withdrawing_roles_No",
                                value: "No",
                                name: "withdrawing_roles",
                                type: "radio",
                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                                disabled: _ctx.disableForm,
                                checked: _ctx.data.selection?.withdrawing_roles === 'No',
                                onChange: _cache[8] || (_cache[8] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.data?.selection?.withdrawing_roles.$touch()))
                            }, null, 42, _hoisted_34)
                        ]),
                        _createTextVNode(),
                        _hoisted_35
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _hoisted_36,
                    _createTextVNode(),
                    (_ctx.v$.data?.selection?.re_advertising.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, "\n                * " + _toDisplayString(_ctx.v$.data?.selection?.re_advertising.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("input", {
                                id: "radio_button_re_advertising_Yes",
                                value: "Yes",
                                name: "re_advertising",
                                type: "radio",
                                class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                disabled: _ctx.disableForm || _ctx.disableReAdvertise,
                                checked: _ctx.model.selection?.re_advertising === 'Yes',
                                onChange: _cache[10] || (_cache[10] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.v$.data?.selection?.re_advertising.$touch()))
                            }, null, 40, _hoisted_41)
                        ]),
                        _createTextVNode(),
                        _hoisted_42
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("input", {
                                id: "radio_button_re_advertising_No",
                                value: "No",
                                name: "re_advertising",
                                type: "radio",
                                class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                disabled: _ctx.disableForm || _ctx.disableReAdvertise,
                                checked: _ctx.model.selection?.re_advertising === 'No',
                                onChange: _cache[12] || (_cache[12] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                onBlur: _cache[13] || (_cache[13] = ($event) => (_ctx.v$.data?.selection?.re_advertising.$touch()))
                            }, null, 40, _hoisted_45)
                        ]),
                        _createTextVNode(),
                        _hoisted_46
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createTextVNode(),
                    _createElementVNode("textarea", {
                        disabled: _ctx.disableForm,
                        value: _ctx.data.additional_comments?.comment,
                        rows: "3",
                        name: "approval_comments",
                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                        onInput: _cache[14] || (_cache[14] =
                            //@ts-ignore
                            (...args) => (_ctx.handleTextInput && _ctx.handleTextInput(...args)))
                    }, null, 40, _hoisted_49)
                ])
            ]),
            _createTextVNode(),
            ((_ctx.profile?.userID?.toUpperCase() === _ctx.data.requestedBy?.toUpperCase() || _ctx.profile?.ADMIN || _ctx.profile?.RESOURCING) && (_ctx.data.currentStageName === 'starter.notifyCVsCollected' || _ctx.data.currentStageName === 'starter.notifyCandidateSelected'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[15] || (_cache[15] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.toggleModal && _ctx.toggleModal(...args)), ["prevent"]))
                    }, "\n          Generate Offers\n        ", 8, _hoisted_51)
                ]))
                : _createCommentVNode("", true),
            _createTextVNode(),
            (_ctx.showModal)
                ? (_openBlock(), _createBlock(_component_ModalWindow, {
                    key: 1,
                    size: "2xl",
                    onClose: _ctx.toggleModal
                }, {
                    icon: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentModalContent.icon), {
                            class: "h-12 w-12 bg-white text-yellow-500",
                            "aria-hidden": "true"
                        }))
                    ]),
                    title: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.currentModalContent.title), 1)
                    ]),
                    subtitle: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.currentModalContent.subtitle), 1)
                    ]),
                    footer: _withCtx(() => [
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-2 bg-green-700 text-base text-white font-medium hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm",
                            onClick: _cache[16] || (_cache[16] =
                                //@ts-ignore
                                (...args) => (_ctx.handleSave && _ctx.handleSave(...args)))
                        }, "\n            Generate Offers and Save\n          "),
                        _createTextVNode(),
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-2 bg-yellow-500 text-base font-medium hover:bg-yellow-600 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm",
                            onClick: _cache[17] || (_cache[17] =
                                //@ts-ignore
                                (...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
                        }, "\n            Generate Offers and Proceed\n          "),
                        _createTextVNode(),
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-2 bg-gray-200 text-base font-medium hover:bg-gray-300 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm",
                            onClick: _cache[18] || (_cache[18] =
                                //@ts-ignore
                                (...args) => (_ctx.toggleModal && _ctx.toggleModal(...args)))
                        }, "\n            Cancel\n          ")
                    ]),
                    _: 1
                }, 8, ["onClose"]))
                : _createCommentVNode("", true)
        ])
    ]));
}
